import { combineReducers } from "redux";
import auth from "./auth";
import currency from "./currency";
import dashboard from "./dashboard";
export default combineReducers({
    auth,
    currency,
    dashboard
});
